import React from 'react';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import withContext from '../../ContextAPI/Context_HOC';
import VideoSwitcher from './FundVideoSwitcher';

const yearEndDate = 'April 30, 2026';
const fundAsOfDate = 'July 06, 2025';
const monthTitle = 'Kalimát/Words';
const nationalFund = '$5,560,373';
const regionalFund = '$559,466';
const continentalFund = '$75,130';
const internationalFund = '$423,217';
const shrineFund = '$40,864,737';
const fundEnglishDownloadLink = 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.7-1+Kalimat+English.pdf';
const fundPersianDownloadLink = 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.7+Kalimat+Persian.pdf';
const fundCurrentFeastImage = 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.7+Kalimat+image.png';

const notes = [
  {
    id: 1,
    text: 'Feast of Raḥmat',
    linkEn: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.6+English_Final.pdf',
    linkFa: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.6+Persian+copy-compressed.pdf',
  },
  {
    id: 2,
    text: 'Feast of Núr',
    linkEn: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.5+Nur+English.pdf',
    linkFa: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.5+Nur+Persian.pdf',
  },
  {
    id: 3,
    text: 'Feast of ‘Aẓamat',
    linkEn: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.4+Azamat+English.pdf',
    linkFa: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.4+Azamat+Persian.pdf',
  },
  {
    id: 4,
    text: 'Feast of Jamál',
    linkEn: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.3+Jamal+English.pdf',
    linkFa: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.3+Jamal+Persian.pdf',
  },
  {
    id: 5,
    text: 'Feast of Jalál',
    linkEn: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.2+Jalal+English.pdf',
    linkFa: 'https://bahai-web.s3.us-east-1.amazonaws.com/Treasury/23.2+Jalal+Persian.pdf',
  },
  {
    id: 6,
    text: 'Feast of Bahá',
    linkEn: 'https://bahai-web.s3.amazonaws.com/Treasury/23.1+Baha+English.pdf',
    linkFa: 'https://bahai-web.s3.amazonaws.com/Treasury/23.1+Baha+Persian.pdf',
  },
  {
    id: 7,
    text: 'Feast of ‘Alá’',
    linkEn: 'https://bahai-web.s3.amazonaws.com/Treasury/22.19+Ala+English.pdf',
    linkFa: 'https://bahai-web.s3.amazonaws.com/Treasury/22.19+Ala+Persian.pdf',
  },
  {
    id: 8,
    text: 'Feast of Mulk',
    linkEn: 'https://bahai-web.s3.amazonaws.com/Treasury/22.18+Mulk+English.pdf',
    linkFa: 'https://bahai-web.s3.amazonaws.com/Treasury/22.18+Mulk+Persian.pdf',
  },
  {
    id: 9,
    text: 'Feast of Sulṭán',
    linkEn: 'https://bahai-web.s3.amazonaws.com/Treasury/22.17+Sultan+English.pdf',
    linkFa: 'https://bahai-web.s3.amazonaws.com/Treasury/22.17+Sultan+Persian.pdf',
  },
];

const FundResources = () => {
  return (
    <div>
      <h2 className="yellowBackgroundTextStyle">Ways To Stay Up to Date on the Bahá’í Fund</h2>
      <div className="containerStyle">
        <div className="boxStyle">
          <VideoSwitcher />
          <p>
            <strong>Office of Treasurer Webinar Recordings</strong>
            <br />
            <small>Please do not copy, share, or distribute this video or any sections of the video</small>
          </p>
          <h3>Stay Connected</h3>
          <p>
            Text: 847–733–3472 and in the message box write “Treasurer”
            <br />
            Have questions? After signing up, text 847–733–3472 and in the message box write your question.
          </p>
        </div>
        <div className="boxStyle">
          <h3>National Fund Update</h3>
          <p>
            <strong>
              For the year ending {yearEndDate}. Contributions as of {fundAsOfDate}:
            </strong>
            <br />
            <br />
            <strong>National Fund:</strong>
            <br />
            <strong className="red-text">{nationalFund}</strong>
            <br />
            <br />
            <strong>Regional Fund:</strong>
            <br />
            <strong className="red-text">{regionalFund}</strong>
            <br />
            <br />
            <strong>Continental Fund:</strong>
            <br />
            <strong className="red-text">{continentalFund}</strong>
            <br />
            <br />
            <strong>International Fund:</strong>
            <br />
            <strong className="red-text">{internationalFund}</strong>
            <br />
            <br />
            <strong>Shrine of ‘Abdu’l-Bahá Fund</strong> (since inauguration of the Fund)
            <br />
            <strong className="red-text">{shrineFund}</strong>
          </p>
          <a
            className="home-button small-bottom-margin full-width center"
            href="https://ocs.bahai.us/ocs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Online Contribution System
          </a>
          <a
            className="home-button small-bottom-margin full-width center"
            href="https://www.bahaitreasurer.us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Office of the Treasurer
          </a>
        </div>
      </div>
      <hr />
      <div className="containerStyle">
        <div className="boxStyle">
          <h3>Treasurers Notes</h3>
          <p>Feast of {monthTitle}</p>
          <p>
            Treasurers Notes are sent out every nineteen days to be read at Feast. Treasurer Notes includes updates on the Bahá’í
            Funds and other Fund related activities.
          </p>
          <div className="containerStyle">
            <a
              className="home-button small-bottom-margin center"
              href={fundEnglishDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Treasurers Notes (English)
            </a>
            <a
              className="home-button small-bottom-margin center"
              href={fundPersianDownloadLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Treasurers Notes (Persian)
            </a>
          </div>

          <Table>
            <thead>
              <TableRow>
                <th className="cellStyle">
                  <strong>Past Notes</strong>
                </th>
                <th className="cellStyle" />
                <th className="cellStyle" />
              </TableRow>
            </thead>
            <tbody>
              {notes.map((note) => (
                <TableRow key={note.id}>
                  <td className="cellStyle" dangerouslySetInnerHTML={{ __html: note.text }} />
                  <td className="cellStyle">
                    (
                    <a href={note.linkEn}>
                      <u>English</u>
                    </a>
                    )
                  </td>
                  <td className="cellStyle">
                    (
                    <a href={note.linkFa}>
                      <u>Persian</u>
                    </a>
                    )
                  </td>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="boxStyle">
          <img src={fundCurrentFeastImage} alt="Bahai Fund Breakdown for Current Feast" className="home-image" />
        </div>
      </div>
    </div>
  );
};

export default withContext(FundResources);
